import type { StageConfigData } from './fluxosPipelineFlow'

// ─── Fallback estático para stage-config (backend offline) ──────────────
export const STATIC_STAGE_CONFIG: StageConfigData = {
  stageOrder: [
    'QUALIFICADO', 'REUNIAO_AGENDADA', 'REUNIAO_REALIZADA',
    'PROPOSTA_ELABORACAO', 'PROPOSTA_ENVIADA', 'TESTE_GRATIS', 'RENEGOCIACAO',
    'GERAR_CONTRATO', 'CONTRATO_ENVIADO', 'HANDOVER',
    'GANHO', 'PERDIDO', 'PAUSADO', 'FECHAMENTO_FUTURO',
  ],
  stages: [
    { id: 'QUALIFICADO', label: 'Qualificado (SQL)', color: '#3B82F6', probability: 20, group: 'active', order: 0, transitions: ['REUNIAO_AGENDADA', 'PERDIDO', 'PAUSADO', 'FECHAMENTO_FUTURO'] },
    { id: 'REUNIAO_AGENDADA', label: 'Reunião Agendada', color: '#8B5CF6', probability: 40, group: 'active', order: 1, transitions: ['REUNIAO_REALIZADA', 'PERDIDO', 'PAUSADO', 'QUALIFICADO', 'FECHAMENTO_FUTURO'] },
    { id: 'REUNIAO_REALIZADA', label: 'Reunião Realizada', color: '#A855F7', probability: 60, group: 'active', order: 2, transitions: ['PROPOSTA_ELABORACAO', 'PERDIDO', 'PAUSADO', 'FECHAMENTO_FUTURO'] },
    { id: 'PROPOSTA_ELABORACAO', label: 'Proposta em Elaboração', color: '#F59E0B', probability: 70, group: 'active', order: 3, transitions: ['PROPOSTA_ENVIADA', 'PERDIDO', 'PAUSADO', 'FECHAMENTO_FUTURO'] },
    { id: 'PROPOSTA_ENVIADA', label: 'Proposta Enviada', color: '#14BDBD', probability: 80, group: 'active', order: 4, transitions: ['GERAR_CONTRATO', 'TESTE_GRATIS', 'RENEGOCIACAO', 'PERDIDO', 'PAUSADO', 'FECHAMENTO_FUTURO'] },
    { id: 'TESTE_GRATIS', label: '30 dias Grátis', color: '#0EA5E9', probability: 75, group: 'active', order: 5, transitions: ['GERAR_CONTRATO', 'RENEGOCIACAO', 'PERDIDO', 'PAUSADO', 'FECHAMENTO_FUTURO'] },
    { id: 'RENEGOCIACAO', label: 'Em Renegociação', color: '#E35933', probability: 65, group: 'active', order: 5, transitions: ['PROPOSTA_ELABORACAO', 'PROPOSTA_ENVIADA', 'PERDIDO', 'PAUSADO', 'FECHAMENTO_FUTURO'] },
    { id: 'GERAR_CONTRATO', label: 'Gerar Contrato', color: '#2563EB', probability: 85, group: 'active', order: 6, transitions: ['CONTRATO_ENVIADO', 'PERDIDO', 'PAUSADO', 'FECHAMENTO_FUTURO'] },
    { id: 'CONTRATO_ENVIADO', label: 'Contrato Enviado', color: '#4F46E5', probability: 90, group: 'active', order: 7, transitions: ['HANDOVER', 'RENEGOCIACAO', 'PERDIDO', 'PAUSADO', 'FECHAMENTO_FUTURO'] },
    { id: 'HANDOVER', label: 'Handover', color: '#0D9488', probability: 95, group: 'active', order: 8, transitions: ['GANHO', 'RENEGOCIACAO', 'PERDIDO', 'PAUSADO', 'FECHAMENTO_FUTURO'] },
    { id: 'GANHO', label: 'Contrato Assinado', color: '#10B981', probability: 100, group: 'closed', order: 9, transitions: [] },
    { id: 'PERDIDO', label: 'Cancelado/Perdido', color: '#EF4444', probability: 0, group: 'closed', order: 10, transitions: ['RENEGOCIACAO'] },
    { id: 'PAUSADO', label: 'Pausado', color: '#6B7280', probability: 10, group: 'inactive', order: 11, transitions: ['QUALIFICADO', 'REUNIAO_AGENDADA', 'REUNIAO_REALIZADA', 'PROPOSTA_ELABORACAO', 'PROPOSTA_ENVIADA', 'RENEGOCIACAO', 'TESTE_GRATIS', 'GERAR_CONTRATO', 'CONTRATO_ENVIADO', 'HANDOVER', 'FECHAMENTO_FUTURO'] },
    { id: 'FECHAMENTO_FUTURO', label: 'Negociação Futura', color: '#6366F1', probability: 30, group: 'inactive', order: 12, transitions: ['REUNIAO_AGENDADA', 'REUNIAO_REALIZADA', 'PROPOSTA_ELABORACAO', 'PROPOSTA_ENVIADA', 'TESTE_GRATIS', 'PAUSADO'] },
  ],
  transitions: [
    { from: 'QUALIFICADO', to: 'REUNIAO_AGENDADA' },
    { from: 'QUALIFICADO', to: 'PERDIDO', color: '#EF4444', label: 'Perda' },
    { from: 'QUALIFICADO', to: 'PAUSADO', dashed: true, color: '#8A8A95' },
    { from: 'QUALIFICADO', to: 'FECHAMENTO_FUTURO', dashed: true, color: '#8A8A95' },
    { from: 'REUNIAO_AGENDADA', to: 'REUNIAO_REALIZADA' },
    { from: 'REUNIAO_AGENDADA', to: 'PERDIDO', color: '#EF4444', label: 'Perda' },
    { from: 'REUNIAO_AGENDADA', to: 'PAUSADO', dashed: true, color: '#8A8A95' },
    { from: 'REUNIAO_AGENDADA', to: 'QUALIFICADO' },
    { from: 'REUNIAO_AGENDADA', to: 'FECHAMENTO_FUTURO', dashed: true, color: '#8A8A95' },
    { from: 'REUNIAO_REALIZADA', to: 'PROPOSTA_ELABORACAO' },
    { from: 'REUNIAO_REALIZADA', to: 'PERDIDO', color: '#EF4444', label: 'Perda' },
    { from: 'REUNIAO_REALIZADA', to: 'PAUSADO', dashed: true, color: '#8A8A95' },
    { from: 'REUNIAO_REALIZADA', to: 'FECHAMENTO_FUTURO', dashed: true, color: '#8A8A95' },
    { from: 'PROPOSTA_ELABORACAO', to: 'PROPOSTA_ENVIADA' },
    { from: 'PROPOSTA_ELABORACAO', to: 'PERDIDO', color: '#EF4444', label: 'Perda' },
    { from: 'PROPOSTA_ELABORACAO', to: 'PAUSADO', dashed: true, color: '#8A8A95' },
    { from: 'PROPOSTA_ELABORACAO', to: 'FECHAMENTO_FUTURO', dashed: true, color: '#8A8A95' },
    { from: 'PROPOSTA_ENVIADA', to: 'GERAR_CONTRATO' },
    { from: 'PROPOSTA_ENVIADA', to: 'TESTE_GRATIS', color: '#0EA5E9', label: '30 dias Grátis' },
    { from: 'PROPOSTA_ENVIADA', to: 'RENEGOCIACAO', color: '#F59E0B', label: 'Renegociação' },
    { from: 'PROPOSTA_ENVIADA', to: 'PERDIDO', color: '#EF4444', label: 'Perda' },
    { from: 'PROPOSTA_ENVIADA', to: 'PAUSADO', dashed: true, color: '#8A8A95' },
    { from: 'PROPOSTA_ENVIADA', to: 'FECHAMENTO_FUTURO', dashed: true, color: '#8A8A95' },
    { from: 'RENEGOCIACAO', to: 'PROPOSTA_ELABORACAO' },
    { from: 'RENEGOCIACAO', to: 'PROPOSTA_ENVIADA' },
    { from: 'RENEGOCIACAO', to: 'PERDIDO', color: '#EF4444', label: 'Perda' },
    { from: 'RENEGOCIACAO', to: 'PAUSADO', dashed: true, color: '#8A8A95' },
    { from: 'RENEGOCIACAO', to: 'FECHAMENTO_FUTURO', dashed: true, color: '#8A8A95' },
    { from: 'TESTE_GRATIS', to: 'GERAR_CONTRATO' },
    { from: 'TESTE_GRATIS', to: 'RENEGOCIACAO', color: '#F59E0B', label: 'Renegociação' },
    { from: 'TESTE_GRATIS', to: 'PERDIDO', color: '#EF4444', label: 'Perda' },
    { from: 'TESTE_GRATIS', to: 'PAUSADO', dashed: true, color: '#8A8A95' },
    { from: 'TESTE_GRATIS', to: 'FECHAMENTO_FUTURO', dashed: true, color: '#8A8A95' },
    { from: 'GERAR_CONTRATO', to: 'CONTRATO_ENVIADO' },
    { from: 'GERAR_CONTRATO', to: 'PERDIDO', color: '#EF4444', label: 'Perda' },
    { from: 'GERAR_CONTRATO', to: 'PAUSADO', dashed: true, color: '#8A8A95' },
    { from: 'GERAR_CONTRATO', to: 'FECHAMENTO_FUTURO', dashed: true, color: '#8A8A95' },
    { from: 'CONTRATO_ENVIADO', to: 'GANHO', color: '#10B981', label: 'Ganho' },
    { from: 'CONTRATO_ENVIADO', to: 'RENEGOCIACAO', color: '#F59E0B', label: 'Renegociação' },
    { from: 'CONTRATO_ENVIADO', to: 'PERDIDO', color: '#EF4444', label: 'Perda' },
    { from: 'CONTRATO_ENVIADO', to: 'PAUSADO', dashed: true, color: '#8A8A95' },
    { from: 'CONTRATO_ENVIADO', to: 'FECHAMENTO_FUTURO', dashed: true, color: '#8A8A95' },
    { from: 'PERDIDO', to: 'RENEGOCIACAO', color: '#E35933', label: 'Renegociação' },
    { from: 'PAUSADO', to: 'QUALIFICADO' },
    { from: 'PAUSADO', to: 'REUNIAO_AGENDADA' },
    { from: 'PAUSADO', to: 'REUNIAO_REALIZADA' },
    { from: 'PAUSADO', to: 'PROPOSTA_ELABORACAO' },
    { from: 'PAUSADO', to: 'PROPOSTA_ENVIADA' },
    { from: 'PAUSADO', to: 'RENEGOCIACAO' },
    { from: 'PAUSADO', to: 'TESTE_GRATIS' },
    { from: 'PAUSADO', to: 'GERAR_CONTRATO' },
    { from: 'PAUSADO', to: 'CONTRATO_ENVIADO' },
    { from: 'PAUSADO', to: 'FECHAMENTO_FUTURO', dashed: true, color: '#8A8A95' },
    { from: 'FECHAMENTO_FUTURO', to: 'REUNIAO_AGENDADA' },
    { from: 'FECHAMENTO_FUTURO', to: 'REUNIAO_REALIZADA' },
    { from: 'FECHAMENTO_FUTURO', to: 'PROPOSTA_ELABORACAO' },
    { from: 'FECHAMENTO_FUTURO', to: 'PROPOSTA_ENVIADA' },
    { from: 'FECHAMENTO_FUTURO', to: 'TESTE_GRATIS' },
    { from: 'FECHAMENTO_FUTURO', to: 'PAUSADO', dashed: true, color: '#8A8A95' },
  ],
  requiredFields: {
    PERDIDO: {
      fields: ['motivoPerda'],
      labels: { motivoPerda: 'Motivo da perda' },
    },
    FECHAMENTO_FUTURO: {
      fields: ['dataFechamentoPrevisto'],
      labels: { dataFechamentoPrevisto: 'Data de fechamento prevista' },
    },
    GANHO: {
      fields: ['observacoes'],
      labels: { observacoes: 'Observação do projeto vendido' },
    },
  },
  groups: [
    { id: 'active', label: 'Ativos', stages: ['QUALIFICADO', 'REUNIAO_AGENDADA', 'REUNIAO_REALIZADA', 'PROPOSTA_ELABORACAO', 'PROPOSTA_ENVIADA', 'TESTE_GRATIS', 'RENEGOCIACAO', 'GERAR_CONTRATO', 'CONTRATO_ENVIADO'] },
    { id: 'closed', label: 'Fechados', stages: ['GANHO', 'PERDIDO'] },
    { id: 'inactive', label: 'Pausados/Futuro', stages: ['PAUSADO', 'FECHAMENTO_FUTURO'] },
  ],
}
